import { Component, OnInit } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-p2-export-procs',
  templateUrl: './p2-export-procs.component.html',
  styleUrls: ['./p2-export-procs.component.css']
})
export class P2ExportProcsComponent implements OnInit {
    public itemsListExportProcedures: Item[] = [];
    public grid?: GridOptions;

    constructor(private datatask: DataTaskService) {

    }

    // private async loadExportProcedures() {
    //     this.itemsListExportProcedures = await this.datatask.Post(891);
    // }

    private async init() {
        // this.loadExportProcedures();
        if (!this.grid || !this.grid.dataTask?.loadData?.method) {
            this.grid = new Grid()
                .setRememberId('w_p2exportproc_grid')
                .setLoadDataFunction({ method: 4061, parameters: {} })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid.gridfunc?.read();
        }
    }

    ngOnInit() {
        this.init();
    }
}
